/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {CompanyRegistrationResourceService} from "@well/resource-services";

@Injectable()
export class SignupLegalEntityInputsService{

  constructor(private companyRegistrationResourceService: CompanyRegistrationResourceService) {
  }

  getCompanyDetailsByUuid(legalEntityUuid: string){
    return this.companyRegistrationResourceService.findOne(legalEntityUuid);
  }

}
